<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="PAs:"
    id="selectPA"
    placeholder="Selecione o(s) PA(s)"
    :multiple="multiple"
    @update:value="handleValueUpdate"
  ></NxSelectReduced>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import PARepository from '../../../../shared/http/repositories/configurations/pa'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectPA',
  mixins: [useReactiveModelMixin('value')],
  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadPAs()
  },
  methods: {
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          let result = response.data.content.map((x) => ({
            value: x.id,
            text: x.descricao
          }))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de PAs', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectPA.vue